import { IEnrollment } from "@wingspanhq/benefits/dist/src/lib/interfaces/enrollment";
import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { getBenefitsEnrollment } from "../../services/benefits";

export const QUERY_BENEFITS_ENROLLMENT = "QUERY_BENEFITS_ENROLLMENT";

export const useQueryBenefitsEnrollment = (
  userId: string,
  queryConfig?: WSQueryConfig<IEnrollment, WSServiceError>
) => {
  return useWSQuery(
    [QUERY_BENEFITS_ENROLLMENT, userId],
    async () => {
      try {
        return await getBenefitsEnrollment(userId);
      } catch {
        return {} as IEnrollment;
      }
    },
    queryConfig
  );
};
